import { render } from "./Blog.vue?vue&type=template&id=0e2ad374&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"

import "./Blog.vue?vue&type=style&index=0&id=0e2ad374&scoped=true&lang=css"

import exportComponent from "/Users/frknalck/Desktop/GelisimPTurkiye/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2ad374"]])

export default __exports__